$(document).ready(function(){
    $('.my-nav').on('click', function() {
        $('.fa', this).toggleClass("fa-chevron-down fa-chevron-up");
    });

    $('#logout').on('click', function(event) {
        event.preventDefault();
        document.getElementById('logout-form').submit();
    });

    $('.no-collapsable').on('click', function (e) {
        e.stopPropagation();
    });

    var observer = lozad('.lozad', {
        threshold: 0.1,
        enableAutoReload: true,
        load: function(el) {
            el.src = el.getAttribute("data-src");
        }
    });

    observer.observe();

    $('.form_zala').on('submit', function() {
        $('#submitBtn').attr('disabled', true);
    });

    $('[data-toggle="tooltip"]').tooltip();

    var buy_btn = $(".buy_btn");
    buy_btn.click(function(e){
        var value = this.value;
        var loading = $(".loading_" + value);
        var cart_txt = $(".cart_txt_" + value);
        loading.removeClass('fa-shopping-cart');
        loading.addClass('fa-spinner fa-spin');
        var cart_total = $(".cart_total");
        var cart_total2 = $(".cart_total2");
        e.preventDefault();
        $.ajax({type: "GET",
            url: window.location.origin + "/ajax/add/" + value,
            success:function(response){
                loading.removeClass('fa-spinner fa-spin');
                if (response.success){
                    // cart_total.removeClass('badge-light');
                    cart_total2.removeClass('badge-light');
                    cart_total2.text(  parseInt(cart_total2.text()) + 1);
                    cart_total2.addClass('badge-success');

                    cart_txt.text('Added to Cart');
                    loading.addClass('fa-check');

                    setTimeout(function(){
                        $("#cart_icon").addClass('shake');
                        cart_total.removeClass('badge-light');
                        cart_total.addClass('badge-danger');
                        cart_total.text(  parseInt(cart_total.text()) + 1);
                        setTimeout(function(){
                            $("#cart_icon").removeClass('shake');
                            cart_total.removeClass('badge-danger');
                            cart_total.addClass('badge-success');
                        },300)
                    },600)

                } else if (response.redirect) {
                    loading.addClass('fa-forward');
                    cart_txt.text('Redirecting');
                    window.location.href = response.url;
                } else if (response.errors) {
                    loading.addClass('fa-exclamation-triangle');
                    cart_txt.text(response.message);
                } else if (response.stock) {
                    $("#buy_btn" + value).removeClass('btn-primary');
                    $("#buy_btn" + value).addClass('btn-danger');
                    loading.addClass('fa-ban');
                    cart_txt.text(response.message);
                } else {
                    cart_txt.html('Cart Error!');
                    loading.addClass('fa-exclamation-triangle');
                }
            }
        });
    });

    $('.qty').change(function(){
        var qty = $(this).val();
        var id = $(this).attr('id');
        if (id && qty) {
            window.location = window.location.origin + "/cart/add_qty/"  + id + '/' + qty;
        }
        return false;
    });

    var btn = $('#zalaTop');

    $(window).scroll(function() {
        if ($(window).scrollTop() > 300) {
            btn.addClass('d-block');
        } else {
            btn.removeClass('d-block');
        }
    });

    btn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop:0}, '300');
    });
});
